import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/tokens.css";
import "./styles/rivplay.css";
import "./styles/app.css";
import App from "./App";

const root = createRoot(document.getElementById("root"));

root.render(<App />);
